<template>
  <div class="content">
    <p>{{ $t('recaptcha.title') }}</p>
    <div class="recaptcha">
    <vue-recaptcha
      ref="recaptcha"
      sitekey="6LeNi9IiAAAAAAx-ern7aCkWGf21KDdOCYn_-eVB"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      loadRecaptchaScript="true"
    ></vue-recaptcha>
  </div>
  </div>

  
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: { VueRecaptcha },
  methods: {
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    onCaptchaVerified: function () {
      this.$router.push('/thankyou');
    },
  },
};
</script>

<style scoped>
.recaptcha {
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
